import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CenSpcIsDeliveryFieldCompletedState from "@tCentro/Store/Reducer/CenSpcIsDeliveryFieldCompletedState";
import { Draft } from "immer";

const initialState: CenSpcIsDeliveryFieldCompletedState = {
    isDeliveryFieldCompletedValue: false,
};

const reducer = {
    "Pages/OnePageCheckout/CenSpcDeliveryFieldCompleted": (
        draft: Draft<CenSpcIsDeliveryFieldCompletedState>,
        action: {
            isDeliveryFieldCompletedValue: boolean;
        },
    ) => {
        draft.isDeliveryFieldCompletedValue = action.isDeliveryFieldCompletedValue;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
